export default {
  title: 'Authentication',
  desc: 'According to the requirements, users need to bind the internal employee ID of Porsche. If you do not complete the binding of the employee ID, you will not be able to enter Porscheopolis. For a better user experience, please fill in the following personal information to complete the employee ID binding.\n*Note: Please fill in your English name and pay attention to letter case and spaces.',
  namePlaceholder: 'Please fill in the employee’s real name',
  jobNumberPlaceholder: 'Please fill in employee ID',
  secretPlaceholder: 'Please enter your key',
  confirm: 'Sure',
  nameLimit: 'Name must be at least 2 characters long',
}
